import { render, staticRenderFns } from "./osTotalizadores.vue?vue&type=template&id=5b2c2920"
import script from "./osTotalizadores.vue?vue&type=script&lang=js"
export * from "./osTotalizadores.vue?vue&type=script&lang=js"
import style0 from "./osTotalizadores.vue?vue&type=style&index=0&id=5b2c2920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports